import template from './customer_report.html';
import controller from './customer_report.controller';
import './customer_report.scss';

let printComponent = {
    restrict: 'E',
    bindings: {},
    template,
    controller
};

export default printComponent;


// WEBPACK FOOTER //
// ./client/app/components/branch_management/components/customer_pickup_reports/print/customer_report.component.js